import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLightningBoltOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLightningBoltOff"><Path d="M10.2816 8.14804L14 3.5L13 10.5H18L15.612 13.4849M8.38338 10.5208L6 13.5H11L10 20.5L13.7184 15.852" stroke="currentColor"/><Path d="M4.5 4.5L19.5 19.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconLightningBoltOff;
